export default "__VITE_ASSET__ad89b5f2__$_?nuxt_component=async&nuxt_component_name=SvgoEnvelopNew02__"